export class PersonalDataSectionsState {
  constructor(state: any) {
    this.application_id = state?.application_id;
    this.is_connection_address_locked = state ? JSON.parse(state.is_connection_address_locked) : null;
    this.connection_address_comment = state?.connection_address_comment;
    this.is_subscriber_owner_locked = state ? JSON.parse(state.is_subscriber_owner_locked) : null;
    this.subscriber_owner_comment = state?.subscriber_owner_comment;
    this.is_invoice_address_locked = state ? JSON.parse(state.is_invoice_address_locked) : null;
    this.invoice_address_comment = state?.invoice_address_comment;
    this.is_operator_of_power_plant_locked = state ? JSON.parse(state.is_operator_of_power_plant_locked) : null;
    this.operator_of_power_plant_comment = state?.operator_of_power_plant_comment;
  }

  application_id: number | null;
  is_connection_address_locked: boolean | null;
  connection_address_comment: string | null;
  is_subscriber_owner_locked: boolean | null;
  subscriber_owner_comment: string | null;
  is_invoice_address_locked: boolean | null;
  invoice_address_comment: string | null;
  is_operator_of_power_plant_locked: boolean | null;
  operator_of_power_plant_comment: string | null;
}

/* The NULL value indicates the comment is untouched or intentionally left with no value - it must be neither lock nor unlock
  https://github.com/bittner-krull/gop-web/issues/412 */
